import React from "react";
import { Button } from "../../../common/Button";
import { ReactComponent as ArrowNext } from "../../../../assets/icons/arrowrightwhite.svg";
import { GetMembershipButton, isOwnerRole } from "./GetMembershipButton";

// TIP-507 — the company-profile CTA slot (owner-only):
//   - member (not yet verified) -> "Get Verified": fires the free, member-only
//     verify request (TIP-491). After requesting -> "in review".
//   - non-member -> "Get Membership" (delegates to GetMembershipButton, which
//     routes to /membership/:companyId).
//   - verified / non-owner -> nothing.
export const ProfileMembershipCta = ({
  companyId,
  role,
  profileStatus,
  onGetVerified = () => {},
  verifyRequested = false,
  verifySubmitting = false,
}) => {
  if (!isOwnerRole(role)) return null;

  if (profileStatus === "member") {
    if (verifyRequested) {
      return (
        <span className="text-white text-[12px] md:text-f16 font-semibold py-1 px-2 sm:py-2 sm:px-3 md:px-6">
          Verification requested — in review
        </span>
      );
    }
    return (
      <Button
        isInvalid={verifySubmitting}
        onClick={verifySubmitting ? undefined : onGetVerified}
        classes={`flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 text-[12px] font-semibold text-white bg-[#FB512D] ${
          verifySubmitting ? "opacity-60 cursor-not-allowed" : ""
        }`}
      >
        {verifySubmitting ? "Requesting…" : "Get Verified"}
        <ArrowNext className="w-[18px] sm:w-auto h-[18px] sm:h-auto" />
      </Button>
    );
  }

  // Non-member (claimed/listed) → Get Membership; verified → null (handled inside).
  return <GetMembershipButton companyId={companyId} role={role} profileStatus={profileStatus} />;
};

export default ProfileMembershipCta;
